module.exports = __webpack_public_path__ + "img/de.3e8db963.svg";